import React from "react";

import STAFF_NOT_AVAILABLE_PNG from "../ui/staff_not_available.png";

interface StaffNotAvailableImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  alt?: string;
}

const StaffNotAvailableImage: React.FC<StaffNotAvailableImageProps> = ({
  alt = "Staff not available",
  ...props
}) => (
  <img
    src={STAFF_NOT_AVAILABLE_PNG}
    alt={alt}
    style={{ width: "100%", height: "auto", maxWidth: 120 }}
    {...props}
  />
);

export default StaffNotAvailableImage;
